import React from 'react';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
import EmptyState from '../components/ui/EmptyState';
import './UnauthorizedPage.css';

function UnauthorizedPage({ onGoHome }) {
  return (
    <div className="unauthorized-page">
      <Card padding="lg" shadow="sm" className="unauthorized-page__card">
        <EmptyState
          icon="⊘"
          headline="You do not have access to this page."
          body="Your current permissions or scope do not allow this view. Use the navigation for a page that matches your assigned access."
          className="unauthorized-page__empty-state"
        />
        <div className="unauthorized-page__actions">
          <Button onClick={onGoHome}>Return to my dashboard</Button>
        </div>
      </Card>
    </div>
  );
}

export default UnauthorizedPage;
